import axios from 'services/axios';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

type PostIgnoreProduct = {
  error_type: any;
};

type PostIgnoreProductParams = {
  operation_id?: string;
  product_id?: string;
};

export const postIgnoreProduct = async ({
  operation_id,
  product_id,
}: PostIgnoreProductParams): Promise<PostIgnoreProduct> => {
  return axios.post(`${VITE_APP_API_URL}/opensearch/v3/ignore-product`, {
    operation_id,
    product_id,
  });
};
